import React from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import SocialMediaLinks from "./Components/SocialMediaLinks";
import Loader from "./Components/Loader";

const SocialMediaLinksPage=()=>{
    return(
        <>
            <Header/>
                <SocialMediaLinks/>
                <Loader/>
            <Footer/>
        </>
    );
}

export default SocialMediaLinksPage;